import { PagedResultEffectWithTotals } from "../types";
import { QueryFormValues } from "./types";
import { bffApi } from "../../../services/bff/bffApi";
import { getErrorMessage } from "../../../utils/getErrorMessage";
import { BaseService } from "../../../global/classes";

export default class ContractEffectsQueryService extends BaseService {
  getContracts = async (
    page: number,
    pageSize: number,
    filter?: QueryFormValues
  ): Promise<PagedResultEffectWithTotals> => {
    const initialDate = filter?.initialDate || null;
    const finalDate = filter?.finalDate || null;
    const merchantId = filter?.merchantId || this.selectedCompany?.merchantId || null;
    const document = filter?.document || null;
    const hash = filter?.hash || null;
    const urValueFilter = filter?.urValueFilter ?? 0;
    const committedValueFilter = filter?.committedValueFilter ?? 0;

    try {
      const response = await bffApi.get(
        `/api/reg/v2/restrictionsinfo/contract-effect-query`,
        {
          params: {
            page,
            pageSize,
            initialDate,
            finalDate,
            merchantId,
            document,
            hash,
            urValueFilter,
            committedValueFilter,
          },
        }
      );

      return response.data as PagedResultEffectWithTotals;
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      console.log(errorMessage);
      throw error;
    }
  };
}
